import { render, staticRenderFns } from "./EdFacebookDestination.vue?vue&type=template&id=13e3a40c&"
import script from "./EdFacebookDestination.vue?vue&type=script&lang=js&"
export * from "./EdFacebookDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports